<template>
  <div>
    <!--style="[opennedWidget ? {opacity: 1, zIndex: 1000, right: '40px'}: {opacity: 0, zIndex: -1, right: '-2000px'}]"  -->
    <div id="app_ask" :style="[!opennedWidget ? {visibility: 'hidden', right: '3000px'} : {visibility: 'visible'}]">
      <WidgetButton :style="{visibility: !getVisibleBtnOfDefaultLang ? 'visible' : 'hidden'}" @click.native="openWidget()"/>
      <Widget v-if="opennedWidget"/>
    </div>
<!--    <p>перевіряє статус livechat при першому запуску || {{getVisibleBtnOfDefaultLang}}</p>-->
<!--    <p>перевіряє глобальну змінну visibleOfLiveChat коли не віп і переходимо до питання (Так чи Ні) || {{visibleOfLiveChat}}</p>-->
  </div>

</template>

<script>
import {serverBus, globalState} from './main'
import {getUser} from './services/getUser'
import {closeWidget} from './services/closeWidget'
import {loadSettings} from './services/loadSettings'
import WidgetButton from './components/WidgetButton'
import Widget from './components/Widget'
import Vue from 'vue'

export default {
  name: 'App',
  mixins: [getUser, closeWidget, loadSettings],
  components: {
    WidgetButton,
    Widget
  },
  data () {
    return {
      opennedWidget: false,
      statusOpenLiveChat: localStorage.getItem('statusLiveChat') || 'maximized',
      liveChatHistory: JSON.parse(localStorage.getItem('liveChatHistory')) || false,
      getVisibleBtnOfDefaultLang: JSON.parse(localStorage.getItem('liveChatHistory')) || false
    }
  },
  computed: {
    visibleOfLiveChat () {
      return globalState.visibleOfLiveChat
    }
  },
  watch: {
    visibleOfLiveChat (value) {
      if (value) {
        this.getVisibleBtnOfDefaultLang = true
      }
    }
  },
  methods: {
    initializeLiveChat () {
      const {initializeScript} = this.liveChatHistory
      var script = document.createElement('script')
      // eslint-disable-next-line no-useless-escape
      script.innerHTML = initializeScript
      document.body.appendChild(script)
    },
    checkLiveChatOpen () {
      let dataLiveChat = JSON.parse(localStorage.getItem('liveChatHistory'))

      if (dataLiveChat) {
        if (dataLiveChat.hasOwnProperty('userInfo') && dataLiveChat.userInfo.langDefault !== this.$ask.lang) {
          this.getVisibleBtnOfDefaultLang = false
          localStorage.removeItem('liveChatHistory')
          localStorage.removeItem('statusLiveChat')
          localStorage.removeItem('getExpireDateOfLiveChat')
          return
        }
      }
      var isWidgetVisible = Boolean(this.liveChatHistory)
      // maybe must delete
      if (isWidgetVisible && !this.checkCloseLiveChatOfAuth()) {
        const statusLsChat = this.statusOpenLiveChat
        this.initializeLiveChat()
        // eslint-disable-next-line no-undef
        LiveChatWidget.on('ready', function () {
          if (statusLsChat === 'maximized') {
            // eslint-disable-next-line no-undef
            LiveChatWidget.call('maximize')
          } else {
            // eslint-disable-next-line no-undef
            LiveChatWidget.call('minimize')
          }
          // eslint-disable-next-line no-undef
          LiveChatWidget.on('visibility_changed', function (data) {
            localStorage.setItem('statusLiveChat', data.visibility)
          })
          // eslint-disable-next-line no-undef
          LiveChatWidget.on('customer_status_changed', function (data) {
            if (data.status === 'browsing') {
              localStorage.removeItem('liveChatHistory')
              localStorage.removeItem('statusLiveChat')
              localStorage.removeItem('getExpireDateOfLiveChat')
            }
          })
        })
      }
    },
    checkUserDataExpiredLS () {
      let now = new Date()
      let storageUserData = JSON.parse(localStorage.getItem('userInfoLS')) || {}
      let storageExpiring = new Date(storageUserData.expires)
      if (storageExpiring < now) {
        localStorage.removeItem('userInfoLS')
      }
    },
    checkExpData () {
      let lastUpdate = localStorage.getItem('getExpireData')
      let last = new Date(lastUpdate)
      let now = new Date()
      let difference = (now - last) / 1000
      if (difference > 60) {
        localStorage.removeItem('dataHistory')
      }
    },
    checkExpDataOfLiveChat () {
      let lastUpdate = localStorage.getItem('getExpireDateOfLiveChat')
      let last = new Date(lastUpdate)
      let now = new Date()
      let difference = (now - last) / 1000
      if (difference > 1800) {
        localStorage.removeItem('liveChatHistory')
        localStorage.removeItem('statusLiveChat')
        localStorage.removeItem('getExpireDateOfLiveChat')
      }
    },
    checkCloseLiveChatOfAuth () {
      if (this.$ask.user_id === '0' || this.$ask.user_id == null) {
        localStorage.removeItem('liveChatHistory')
        localStorage.removeItem('statusLiveChat')
        localStorage.removeItem('getExpireDateOfLiveChat')
        return true
      }
    },
    openWidget () {
      if (this.$settings.widget_type_code === 'live_chat') {
        if (this.opennedWidget && this.$settings.use_widget === 0) {
          // eslint-disable-next-line no-undef
          LiveChatWidget.call('maximize')
        }
        let dataLiveChat = JSON.parse(localStorage.getItem('liveChatHistory'))

        if (dataLiveChat) {
          if (dataLiveChat.hasOwnProperty('userInfo') && dataLiveChat.userInfo.langDefault !== this.$ask.lang) {
            this.getVisibleBtnOfDefaultLang = false
          }
        }
      }
      this.opennedWidget = true
      this.bodyScroll(false)
    },
    bodyScroll (task) {
      if (window.innerWidth <= 992 && !task) {
        document.body.classList.add('scroll_disabled')
      } else if (window.innerWidth <= 992 && task) {
        document.body.classList.remove('scroll_disabled')
      }
    }
  },
  created () {
    this.getUser()
    this.checkUserDataExpiredLS()
    this.checkExpDataOfLiveChat()
    this.checkExpData()
    this.checkCloseLiveChatOfAuth()

    serverBus.$on('closingWidget', () => {
      this.bodyScroll(true)
      this.opennedWidget = false
    })
    serverBus.$on('apiCloseWidget', () => {
      if (this.opennedWidget === true) this.closeWidget()
    })
    serverBus.$on('openingWidget', () => {
      this.ask = this.$ask
      if (this.$settings) {
        this.bodyScroll(false)
        this.opennedWidget = true
      }
    })
    serverBus.$on('reloadWidget', () => {
      this.opennedWidget = false
      this.getUser()
    })
    // eslint-disable-next-line
    if (this.$ask.user_id == 0 || this.$ask.user_id == null) {
      Vue.prototype.$registered = false
    } else {
      Vue.prototype.$registered = true
    }
    // if (this.$registered) {
    //   // eslint-disable-next-line
    //   Vue.prototype.$webimInfo = webim_visitor.fields.info
    // }
  },
  mounted () {
    this.checkLiveChatOpen()
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue